<ion-header>
  <ion-toolbar>
    <ion-title>Items</ion-title>
    <ion-buttons slot="end">
      <ion-button class="ion-text-capitalize" (click)="onSaveClick()">Save</ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button class="ion-text-capitalize" (click)="onCloseClick()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form *ngIf="form" [formGroup]="form">
    <ion-list formArrayName="items">
      <ion-item *ngFor="let item of menuItems; let i = index" lines="full" button (click)="onItemClick($event, item, i)">
        <ion-thumbnail slot="start">
          <img *ngIf="item.iconImage" [src]="item.iconImage.url">
          <img *ngIf="!item.iconImage" src="https://ionicframework.com/docs/demos/api/thumbnail/thumbnail.svg" alt=""
            srcset="">
        </ion-thumbnail>
        <ion-label class="ion-text-capitalize">
          <h2 [innerText]="item.name"></h2>
          <p class="tags">
            <ion-icon name="pricetags-outline"></ion-icon>
            <span [innerText]="item.tags?.join(', ')"></span>
          </p>
        </ion-label>
        <ion-checkbox slot="end" [formControlName]="i" (click)="$event.stopPropagation()"></ion-checkbox>
      </ion-item>
    </ion-list>
  </form>
</ion-content>
